import { apiPost, apiGet } from '../api';

import { CALL_CENTER_ROLE } from '../constants';
import { callCenterLoginEvent } from '../events/User';
import { sendGTMEvents } from './Booking';
import { deleteCookie } from '../services/cookies';

export const setShowAlertMobileLand = (value) => ({ type: 'SESSION_SET_ALERTMOBILELAND', value });
export const setTheme = (theme) => ({ type: 'SESSION_SET_THEME', theme });
export const setUser = (user) => ({ type: 'SESSION_SET_USER', user });

// The API will require new functionality if we want to handle customer users login / logout
export const logoutUser = () => (dispatch, getState) => {
  const state = getState();
  const body = { session: state.bookingFormState.sessionId };
  return apiPost('api-pb/callcenter/logout/', body).then(() => {
    deleteCookie('login-details');
    dispatch(setUser(null));
    const event = callCenterLoginEvent({ isLoggedIn: false });
    dispatch(sendGTMEvents([event]));
  });
};

export const loginUser = (user) => (dispatch, getState) => {
  const state = getState();
  const { chain, sessionId } = state.bookingFormState;
  const body = {
    ...user,
    session: sessionId,
    chain,
  };
  return apiPost('api-pb/callcenter/login/', body).then((userResponse) => {
    let currentUser = null;
    if (userResponse.pk) {
      currentUser = {
        ...userResponse.user,
        isAnonymous: false,
        role: CALL_CENTER_ROLE,
      };
      const event = callCenterLoginEvent({ isLoggedIn: true });
      dispatch(sendGTMEvents([event]));
    }
    dispatch(setUser(currentUser));
    return true;
  }).catch(() => {
    dispatch(setUser(null));
    const event = callCenterLoginEvent({ isLoggedIn: false });
    dispatch(sendGTMEvents([event]));
    return false;
  });
};

/* Requests the API to send an email if the username / email matches one in the system */
export const requestPasswordReset = (emailOrUsername) => () => (
  apiPost('api-pb/reset-password/', { user: emailOrUsername }).then((resetResponse) => (
    { success: resetResponse.is_success }
  )).catch((e) => ({ success: false, errorMsg: e }))
);

/* Requests the API to reset the password of a user who received an email from the previous function */
export const submitPasswordReset = (data) => () => (
  apiPost('api-pb/reset-password/update/', data).then((resetResponse) => (
    { success: resetResponse.is_success }
  )).catch((e) => ({ success: false, errorMsg: e }))
);

export const loadAndConfigureChain = (chainCode) => (dispatch) => {
  const chainToken = process.env[`${chainCode}_CHAIN`];
  apiGet(`api-pb/chain/${chainToken}/`).then((chainData) => {
    dispatch({ type: 'SESSION_SET_CHAIN_DATA', chainData });
  });
};

export const initSession = () => (dispatch, getState) => {
  const state = getState();
  return getSessionId(state).then(({ sessionId }) => {
    // Guardamos la sesión
    dispatch(setSessionId(sessionId));
  }).catch(() => {
    dispatch(setSessionId(null));
  });
};

// We could see if we can export and use the ones in bookingform instead
export const getSessionId = (state) => {
  const session = state.bookingFormState.sessionId;
  if (session) {
    return Promise.resolve({ sessionId: session, isNew: false });
  }

  const { lang } = state.i18nState;
  return apiGet('api-pb/session-key/', lang).then((data) => ({
    sessionId: data.session_key,
    isNew: true,
  }));
};

const setSessionId = (session) => (
  { type: 'BOOKINGFORM_SET_SESSIONID', session }
);

/* Sets whether or not a booking creation is in progress */
export const setCreatingBooking = (creatingBooking) => ({
  type: 'SESSION_SET_IS_CREATING_BOOKING', creatingBooking,
});

/* Sets the call center customer code which is being used by the call center user */
export const setCallCenterCustomerCode = (callCenterCustomerCode) => ({
  type: 'BOOKING_SET_CALL_CENTER_CUSTOMER_CODE', callCenterCustomerCode,
});

/* Sets the opening state of the reservation details of the new shopping cart detail in mobile*/
export const setOpenReservationDetails = (openReservationDetails) => ({
  type: 'BOOKING_SET_OPEN_RESERVATION_DETAILS', openReservationDetails,
});
